// extracted by mini-css-extract-plugin
export default {"wrapper":"UserEmulation_wrapper__+fpy-","header":"UserEmulation_header__yYK77"};